module.exports = {"451102001":"八步街道","451102002":"城东街道","451102003":"江南街道","451102101":"贺街镇","451102102":"步头镇","451102103":"莲塘镇","451102104":"大宁镇","451102105":"南乡镇","451102106":"桂岭镇","451102107":"开山镇","451102109":"里松镇","451102114":"信都镇","451102115":"灵峰镇","451102116":"仁义镇","451102117":"铺门镇","451102200":"黄洞瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451102.json
// module id = 1978
// module chunks = 0